import * as React from "react"
import styled from "styled-components"
import { Flex, Text } from ".."
import { bodyFontFamily, colors, scale } from "../../styles"

export interface TextareaProps
	extends Omit<React.HTMLProps<HTMLTextAreaElement>, "ref" | "as" | "value"> {
	label: string
	helperText?: string
	error?: boolean
	inputRef?: React.Ref<HTMLTextAreaElement>
}

const TextareaStyled = styled.textarea<TextareaProps>`
	display: flex;
	flex: 1;
	width: 100%;
	border: solid ${({ error }) => colors[error ? "alert" : "blue33"]} 1px;
	border-radius: ${scale.px(0.5)};
	color: ${({ error }) => colors[error ? "alert" : "navy"]};
	outline: none;
	font-family: ${bodyFontFamily};
	font-size: ${scale.px(2)};
	line-height: ${scale.px(3)};
	padding: ${scale.px(2)};

	&::placeholder {
		color: ${colors.placeholder};
	}

	&:focus {
		border-color: ${({ error }) => colors[error ? "alert" : "navy"]};
	}

	&:disabled {
		background-color: ${colors.white};
		cursor: not-allowed;
	}

	/* overide any browser specific or plugin prefill styles */
	&[style] {
		background: ${colors.white} !important;
	}
`

const Label = styled.label`
	font-size: ${scale.px(1.75)};
	line-height: ${scale.px(2.5)};
	margin-bottom: ${scale.px(0.5)};
`

const Textarea: React.FC<TextareaProps> = ({
	label,
	helperText,
	inputRef,
	...rest
}) => {
	return (
		<Flex flexDirection="column" flex={1}>
			<Label htmlFor={rest.id}>{label}</Label>
			<TextareaStyled
				ref={inputRef}
				label={label}
				aria-invalid={rest.error ? "true" : "false"}
				{...rest}
			/>
			<Flex w={1} minh={helperText ? "none" : 3} justifyContent="flex-end">
				<Text
					as="span"
					textColor={rest.error ? "alert" : "navy"}
					fontSize={1.75}
					lineHeight={2.5}
					mt={0.5}
					mb={0}
				>
					{helperText}
				</Text>
			</Flex>
		</Flex>
	)
}

export { Textarea }
